import { useState } from "react";
import {
  IconButton,
  Checkbox,
  Typography,
  Box,
  Card,
  List,
  Stack,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";
export const stringToLocale = (dateString) => {
  const options = {
    year: "numeric",
    month: "long"
  };

  const date = new Date(dateString);
  if (isNaN(date)) {
    return "Invalid Date";
  }
  return date.toLocaleDateString(navigator.language, options);
};

function EducationCard({ certifications = [], handleToggle }) {
  const [isExpanded, setIsExpanded] = useState(true);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_USER_EDUCATION_INFO = English.ResumeBuilder.TEXT_USER_EDUCATION_INFO,
    TEXT_NO_TRADES_TO_PROFILE = English.ResumeBuilder.TEXT_NO_TRADES_TO_PROFILE
  } = LanguageData || {};

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{TEXT_USER_EDUCATION_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <List disablePadding>
          {certifications.length > 0 ? (
            <Stack spacing={1} pt={1}>
              {certifications.map((cert, index) => {
                const displayEndDate = cert?.endDate ? stringToLocale(cert?.endDate) : "Present";
                return (
                  <Card
                    key={index.toString()}
                    className="pagelist-content"
                    sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
                    <ListItem
                      key={index.toString()}
                      alignItems="flex-start"
                      sx={{ m: 0, p: 0 }}
                      secondaryAction={
                        <Checkbox
                          edge="end"
                          onChange={() => handleToggle(cert.id, "EducationCard")}
                          checked={cert.isSelected}
                        />
                      }>
                      <ListItemButton
                        onClick={() => handleToggle(cert.id, "EducationCard")}
                        alignItems="flex-start"
                        sx={{ m: 0 }}>
                        <ListItemText
                          primary={<Typography variant="body1">{cert?.school}</Typography>}
                          secondary={
                            <Box>
                              <Stack>
                                <Typography variant="body2">{cert?.fieldOfStudy}</Typography>
                                {cert?.tradeReceived && (
                                  <Typography variant="body2">{cert?.tradeReceived}</Typography>
                                )}
                                <Typography variant="body2">
                                  {stringToLocale(cert?.startDate)} - {displayEndDate}
                                </Typography>
                              </Stack>
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                );
              })}
            </Stack>
          ) : (
            <Typography>{TEXT_NO_TRADES_TO_PROFILE}</Typography>
          )}
        </List>
      )}
    </Card>
  );
}

export default EducationCard;
